class Wishlist {
  constructor() {
    this.storageKey = "shopify_wishlist";
    this.init();
  }

  init() {
    this.bindButtons();
    this.updateCount();

    document.addEventListener("DOMContentLoaded", () => {
      this.bindButtons();
      this.updateCount();
    });
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.storageKey);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  saveWishlist(wishlist) {
    localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
  }

  add(handle) {
    let wishlist = this.getWishlist();

    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
      this.saveWishlist(wishlist);
    }

    this.updateIcons();
    this.updateCount();
  }

  remove(handle) {
    let wishlist = this.getWishlist();

    wishlist = wishlist.filter(item => item !== handle);

    this.saveWishlist(wishlist);

    this.updateIcons();
    this.updateCount();

    const card = document.querySelector(
      `.wishlist-product[data-handle="${handle}"]`
    );

    if (card) {
      card.remove();
    }
  }

  toggle(handle) {
    let wishlist = this.getWishlist();

    if (wishlist.includes(handle)) {
      this.remove(handle);
    } else {
      this.add(handle);
    }
  }

  exists(handle) {
    return this.getWishlist().includes(handle);
  }

  bindButtons() {
    document.querySelectorAll(".wishlist-btn").forEach(button => {
      if (button.dataset.bound === "true") return;

      button.dataset.bound = "true";

      const handle = button.dataset.handle;

      if (this.exists(handle)) {
        button.classList.add("active");
      }

      button.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();

        this.toggle(handle);
      });
    });
  }

  updateIcons() {
    document.querySelectorAll(".wishlist-btn").forEach(button => {
      const handle = button.dataset.handle;

      if (this.exists(handle)) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  }

  updateCount() {
    const count = this.getWishlist().length;

    document.querySelectorAll(".wishlist-count").forEach(el => {
      el.textContent = count;
    });
  }

  async renderWishlist(containerSelector) {
    const container = document.querySelector(containerSelector);

    if (!container) return;

    const handles = this.getWishlist();

    if (handles.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <h2>Your wishlist is empty.</h2>
        </div>
      `;
      return;
    }

    container.innerHTML = "";

    for (const handle of handles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        const product = await response.json();

        const image = product.featured_image;

        const html = `
          <div class="wishlist-product" data-handle="${handle}">

            <a href="/products/${handle}">
              <img src="${image}" alt="${product.title}">
            </a>

            <h3>
              <a href="/products/${handle}">
                ${product.title}
              </a>
            </h3>

            <p class="price">
              ${(product.price / 100).toFixed(2)}
            </p>

            <button
              class="wishlist-remove"
              data-handle="${handle}">
              Remove
            </button>

            <button
              class="wishlist-add-cart"
              data-variant="${product.variants[0].id}">
              Add to Cart
            </button>

          </div>
        `;

        container.insertAdjacentHTML("beforeend", html);
      } catch (err) {
        console.error(err);
      }
    }

    this.bindWishlistPage();
  }

  bindWishlistPage() {
    document.querySelectorAll(".wishlist-remove").forEach(btn => {
      btn.onclick = () => {
        this.remove(btn.dataset.handle);
      };
    });

    document.querySelectorAll(".wishlist-add-cart").forEach(btn => {
      btn.onclick = () => {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: btn.dataset.variant,
            quantity: 1
          })
        })
          .then(() => {
            alert("Added to cart");
          })
          .catch(console.error);
      };
    });
  }
}

window.ShopifyWishlist = new Wishlist();

document.addEventListener("shopify:section:load", () => {
  window.ShopifyWishlist.bindButtons();
  window.ShopifyWishlist.updateIcons();
  window.ShopifyWishlist.updateCount();
});